export type MissionType =
  | "distance"       // drive N metres in one run
  | "coins_in_run"   // collect N coins in a single run
  | "powerup_uses"   // collect N power-ups (any) across the day
  | "lifetime_coins" // total coins earned today
  | "lane_changes";  // change lanes N times in a single run

export interface MissionTemplate {
  type: MissionType;
  goalChoices: number[];
  rewardPerUnit: number;
  base: number;
  label: (goal: number) => string;
}

export const TEMPLATES: MissionTemplate[] = [
  {
    type: "distance",
    goalChoices: [1500, 2500, 4000],
    rewardPerUnit: 0.1,
    base: 50,
    label: (g) => `Drive ${g.toLocaleString()}m in a single run`,
  },
  {
    type: "coins_in_run",
    goalChoices: [80, 150, 250],
    rewardPerUnit: 1,
    base: 50,
    label: (g) => `Collect ${g} coins in a single run`,
  },
  {
    type: "powerup_uses",
    goalChoices: [3, 6, 10],
    rewardPerUnit: 25,
    base: 50,
    label: (g) => `Pick up ${g} power-ups today`,
  },
  {
    type: "lifetime_coins",
    goalChoices: [500, 1500, 3000],
    rewardPerUnit: 0.1,
    base: 50,
    label: (g) => `Earn ${g} coins total today`,
  },
  {
    type: "lane_changes",
    goalChoices: [30, 60, 100],
    rewardPerUnit: 1.5,
    base: 50,
    label: (g) => `Change lanes ${g} times in a run`,
  },
];
